export default "/fonts/poppins-v9-latin-regular.svg?d216b7324daba0b4f3e713b0e7f9e6c2";